import defineMessages from "../../../../../common/helpers/defineMessages";

const messages = defineMessages({
    title: {
        id: "intro.plan.title",
    },
    title1: {
        id: "intro.plan.1.title",
    },
    title2: {
        id: "intro.plan.2.title",
    },
    title3: {
        id: "intro.plan.3.title",
    },
    description1: {
        id: "intro.plan.1.description",
    },
    description2: {
        id: "intro.plan.2.description",
    },
    description3: {
        id: "intro.plan.3.description",
    },
});

export default messages;
